define(["exports", "./utils", "../core/l10n", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _l10n, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<h2>Best Practices Summary</h2>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["", ": ", ""]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n        <li>\n          ", ": ", "\n        </li>\n      "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n      <a class=\"marker self-link\" href=\"", "\"><bdi lang=\"", "\">", "", "</bdi></a>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/best-practices";
  _exports.name = name;
  const localizationStrings = {
    en: {
      best_practice: "Best Practice "
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";

  function run() {
    /** @type {NodeListOf<HTMLElement>} */
    const bps = document.querySelectorAll(".practicelab");
    const l10n = localizationStrings[lang];
    const bpSummary = document.getElementById("bp-summary");
    const summaryItems = bpSummary ? document.createElement("ul") : null;
    [...bps].forEach((bp, num) => {
      const id = (0, _utils.addId)(bp, "bp");
      const localizedBpName = (0, _hyperhtml.default)(_templateObject(), "#".concat(id), lang, l10n.best_practice, num + 1); // Make the summary items, if we have a summary

      if (summaryItems) {
        const li = (0, _hyperhtml.default)(_templateObject2(), localizedBpName, (0, _utils.makeSafeCopy)(bp));
        summaryItems.appendChild(li);
      }

      const container = bp.closest("div");

      if (!container) {
        // This is just an inline best practice...
        bp.classList.add("advisement");
        return;
      } // Make the advisement box


      container.classList.add("advisement");
      const title = (0, _hyperhtml.default)(_templateObject3(), localizedBpName.cloneNode(true), bp);
      container.prepend(...title.childNodes);
    });

    if (bps.length) {
      if (bpSummary) {
        bpSummary.appendChild((0, _hyperhtml.default)(_templateObject4()));
        bpSummary.appendChild(summaryItems);
      }
    } else if (bpSummary) {
      (0, _pubsubhub.pub)("warn", "Using best practices summary (#bp-summary) but no best practices found.");
      bpSummary.remove();
    }
  }
});
//# sourceMappingURL=best-practices.js.map